import { deepFreeze } from '@/utils/deep-freeze.js';
import get from 'lodash/get';

let activeSubProductLinesMap;

export function setActiveProductLinesMap (plMapByType) {
    activeSubProductLinesMap = deepFreeze(structuredClone(plMapByType));
}

const NAME_MAP = {
    core: 'Pendo',
    feedback: 'Feedback (classic)',
};

export function convertProductLinesArrayToMap (plList = []) {
    return plList.reduce((acc, pl) => {
        pl.enabled = getProductLineEnabledStatus(pl);
        pl.displayName = NAME_MAP[pl.type] || pl.displayName;
        acc[pl.type] = pl;

        return acc;
    }, {});
}

// we really should get rid of this check altogether, but its used in several places
export function getProductLineEnabledStatus (productLine) {
    const isFeedbackPlAndLoginEnabled =
        productLine.type === 'feedback' && get(productLine, 'metadata.unifiedLoginEnabled', false);

    return productLine.purchased && (productLine.configured || isFeedbackPlAndLoginEnabled);
}

export function getActiveSubProductLine (productLineName) {
    return getProductLine(activeSubProductLinesMap, productLineName);
}

export function activeSubHasPurchasedProductLine (productLineName, metadataFieldName) {
    return hasPurchasedProductLine(activeSubProductLinesMap, productLineName, metadataFieldName);
}

// Generic getters for cases where you're looking at a sub other than the currently active sub
export function getProductLine (plMap, productLineName) {
    return plMap[productLineName];
}

export function hasPurchasedProductLine (plMap, productLineName, metadataFieldName) {
    if (!plMap) {
        // eslint-disable-next-line no-console
        console.warn(`attempting to check product line ${productLineName} before product lines have loaded`);

        return false;
    }

    if (!plMap[productLineName]) {
        // eslint-disable-next-line no-console
        console.warn(`attempting to check product line ${productLineName} which does not exist`);

        return false;
    }

    // allow purchased check to also be applied prior to evaluating `metadataFieldName`
    if (!plMap[productLineName].purchased) return false;

    if (!metadataFieldName) return true;

    return !!get(plMap[productLineName], `metadata.${metadataFieldName}`, false);
}
